import React, {Component} from 'react';
import {setBehaviourVariables} from '../actions';
import {calculateRecommendedWrf} from '../utils/behaviour_models/vesta_mk2/wrf';

const FIELDS = [
  { key: 'overstorey_cover', label: 'Overstorey Cover (%)', min: 0, max: 100 },
  { key: 'overstorey_height', label: 'Overstorey Height (m)', min: 0, max: 200 },
  { key: 'tall_understorey_cover', label: 'Tall Understorey Cover (%)', min: 0, max: 100 }
];

class RecommendedWrfDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overstorey_cover: props.variables.overstorey_cover,
      overstorey_height: props.variables.overstorey_height,
      tall_understorey_cover: props.variables.tall_understorey_cover
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleAccept = this.handleAccept.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      this.setState({
        overstorey_cover: this.props.variables.overstorey_cover,
        overstorey_height: this.props.variables.overstorey_height,
        tall_understorey_cover: this.props.variables.tall_understorey_cover
      });
    }
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: Number(value) });
  }

  handleCancel(event) {
    event.preventDefault();
    this.props.onClose();
  }

  handleAccept(event) {
    event.preventDefault();
    const recommended = calculateRecommendedWrf(
      this.state.overstorey_cover,
      this.state.overstorey_height,
      this.state.tall_understorey_cover
    );
    if (typeof recommended === 'undefined') {
      return;
    }
    this.props.dispatch(setBehaviourVariables(this.props.data_set, {
      ...this.props.variables,
      overstorey_cover: this.state.overstorey_cover,
      overstorey_height: this.state.overstorey_height,
      tall_understorey_cover: this.state.tall_understorey_cover,
      wind_reduction_factor: Math.round(recommended * 100) / 100
    }));
    this.props.onClose();
  }

  render() {
    if (!this.props.open) {
      return null;
    }

    const recommended = calculateRecommendedWrf(
      this.state.overstorey_cover,
      this.state.overstorey_height,
      this.state.tall_understorey_cover
    );
    const currentWrf = this.props.variables.wind_reduction_factor;
    const canAccept = typeof recommended !== 'undefined';

    return <div className="c-form__variables-form-holder">
      <div className="c-form__variables-form c-form__recommended-wrf-form">
        <div className="c-form__recommended-wrf-heading">Recommended Wind Reduction Factor</div>
        {FIELDS.map((field) =>
          <div key={field.key}>
            <label>{field.label}: </label>
            <input name={field.key}
                   type="number"
                   min={field.min}
                   max={field.max}
                   value={this.state[field.key]}
                   onChange={this.handleChange}/>
          </div>
        )}
        <div className="c-form__recommended-wrf-result">
          {canAccept
            ? <span>Recommended WRF: <strong>{recommended.toFixed(2)}</strong> (current: {currentWrf})</span>
            : <span className="c-form__error-messsage">Cannot calculate a recommended WRF for these inputs.</span>
          }
        </div>
        <div className="c-form__buttons">
          <a className="c-form__cancel-button" onClick={this.handleCancel}>
            <i className="fa fa-times-circle"/><span>Cancel</span>
          </a>
          <a className={canAccept ? 'c-button c-form__submit-button' : 'c-form__cancel-button'}
             onClick={canAccept ? this.handleAccept : this.handleCancel}>
            <i className="fa fa-check-square"/><span>Accept WRF</span>
          </a>
        </div>
      </div>
    </div>;
  }
}

export default RecommendedWrfDialog;



// WEBPACK FOOTER //
// ./src/components/RecommendedWrfDialog.js